export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="embed-responsive embed-responsive-16by9">
            <video className="embed-responsive-item" width="560" height="315" controls autoPlay muted>
              <source src="https://yes35.ru/images/glkvideo.mp4" type="video/mp4" />
              Ваш браузер не поддерживает видео.
            </video>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>О проекте</h2>
              <p>Хотите, чтобы ваш ребенок освоил зимние виды спорта и научился безопасно и с удовольствием кататься на горных лыжах? Тогда школа ГЛК – это то, что вам нужно! Опытный инструктор поможет ребенку овладеть необходимыми навыками катания, а также подготовит к соревнованиям. Благодаря занятиям повышается сила, выносливость и координация движений.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
